var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketingFunnelOptimizationGoal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.503 4.813H4.497a.999.999 0 00-.86 1.5l7.27 12.668v7.206c0 .554.443 1 .993 1h8.2c.55 0 .994-.446.994-1v-7.206l7.272-12.669c.381-.665-.097-1.5-.863-1.5zm-8.647 20.125h-5.712v-4.625h5.716v4.625h-.004zm.3-7.082l-.262.456h-5.79l-.263-.456-2.39-4.169h11.1l-2.395 4.17zm3.541-6.169H9.303L6.647 7.064h18.706l-2.656 4.625z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/marketing-funnel-optimization-goal.f671671d8b70f1455d52f870515c57c4.svg";
export { SvgMarketingFunnelOptimizationGoal as ReactComponent };